export function productIds(value) {
  if (typeof value === "string") {
    try { value = JSON.parse(value); } catch { return []; }
  }
  return Array.isArray(value) ? [...new Set(value.filter((id) => id != null).map(String))] : [];
}

export const sameProducts = (left, right) => {
  const a = productIds(left).sort();
  const b = productIds(right).sort();
  return a.length === b.length && a.every((id, index) => id === b[index]);
};

export function upsellError(error, fallback = "Something went wrong. Please try again.") {
  const data = error?.response?.data || error;
  const errors = data?.errors || data?.data?.errors;
  const validation = errors && Object.values(errors).flat().find((value) => typeof value === "string");
  return validation || (typeof data?.msg === "string" && data.msg) || data?.message || fallback;
}

export function requireSuccess(response) {
  if (Number(response?.status || response?.code) !== 200) {
    throw new Error(upsellError(response));
  }
  return response.data;
}

export const matchesProduct = (product, query) =>
  [product?.title, product?.handle, product?.product_id].filter(Boolean).join(" ").toLowerCase().includes(query.trim().toLowerCase());
